import nyNetwork from "@/api/nyBaseNetwork";
import DZModelWiki from "@/views/百科管理/model/DZModelWiki";
import DZModelWikiType from "@/views/百科管理/model/DZModelWikiType";
import DZModelWikiSearch from "@/views/百科管理/model/DZModelWikiSearch";
import DZModelWikiLabel from "@/views/百科管理/model/DZModelWikiLabel";
import DZModelPage from "@/model/DZModelPage";


class DZServiceWiki {

    m_search = new DZModelWikiSearch();

    list_wiki : Array<DZModelWiki> = [];

    list_type : Array<DZModelWikiType> = [];

    list_label : Array<DZModelWikiLabel> = [];

    m_type = new DZModelWikiType();

    m_label = new DZModelWikiLabel();

    m_page = new DZModelPage(10);

    /** 分类 **/
    net_add_type(success: () => void){
        nyNetwork.net("添加百科分类",this.m_type, data => {
            success()
        })
    }

    net_edit_type(success: () => void){
        nyNetwork.net("编辑百科分类",this.m_type, data => {
            success()
        })
    }

    net_page_type(m_search){
        nyNetwork.net("百科分类列表",m_search, data => {
            this.list_type = data.list
            this.m_search.total = data.total
        })
    }

    net_all_type(){
        nyNetwork.net("百科分类所有",{}, data => {
            this.list_type = data
        })
    }

    net_delete_type(id,success: () => void){
        nyNetwork.net("删除百科分类",{id:id}, data => {
            success()
        })
    }

    /** 百科列表 **/
    net_page_list_wiki(){
        nyNetwork.net("百科分页列表",this.m_search, data => {
            this.list_wiki = data.list
            this.m_search.total = data.total
        })
    }

    net_add_wiki(m_wiki,success: () => void){
        nyNetwork.net("添加百科",m_wiki, data => {
            success();
        })
    }

    net_edit_wiki(m_wiki,success: () => void){
        nyNetwork.net("编辑百科",m_wiki, data => {
            success();
        })
    }

    net_del_wiki(id,success: () => void){
        nyNetwork.net("删除百科",{id:id}, data => {
            success();
        })
    }

    /** 标签 **/
    net_add_label(success: () => void){
        nyNetwork.net("添加百科标签",this.m_label, data => {
            success();
        })
    }

    net_edit_label(success: () => void){
        nyNetwork.net("编辑百科标签",this.m_label, data => {
            success();
        })
    }

    net_del_label(id,success: () => void){
        nyNetwork.net("删除百科标签",{id:id}, data => {
            success();
        })
    }

    net_page_label(m_page){
        nyNetwork.net("百科标签分页",m_page, data => {
            this.list_label = data.list
            this.m_page.total = data.total
        })
    }

    net_list_label(){
        nyNetwork.net("百科标签列表",{}, data => {
            this.list_label = data
        })
    }

}
export default DZServiceWiki;
